type AppEnvironment = 'smsv3' | 'agni' | 'reddata' | 'ranksitt' | 'fahimit' | 'voice' | 'default'

interface EnvironmentConfiguration {
  appId: number
  baseUrl: string // API BASE URL
}

const ENVIRONMENT_CONFIG: Record<AppEnvironment, EnvironmentConfiguration> = {
  smsv3: {
    appId: 4, // this value can be changes while developing
    baseUrl: 'https://apismsv3.iatlbd.com',
  },
  agni: {
    appId: 2,
    baseUrl: 'https://smscapi.agni.com',
  },
  reddata: {
    appId: 2,
    baseUrl: 'https://sms.reddata.com.bd',
  },
  ranksitt: {
    appId: 2,
    baseUrl: 'https://bsmsapi.ranksitt.net',
  },
  fahimit: {
    appId: 3,
    baseUrl: 'https://panel.bulksmsbd.org',
  },
  voice: {
    appId: 4,
    baseUrl: 'https://apismsv3.iatlbd.com',
  },
  default: {
    appId: 0,
    baseUrl: 'https://apismsv3.iatlbd.com',
  },
}

const HOSTNAME_TO_ENVIRONMENT: Record<string, AppEnvironment> = {
  // Localhost | development environment
  localhost: 'smsv3',
  'smsv3.iatlbd.com': 'smsv3',

  // Agni smsc environment
  'smsc.agni.com': 'agni',

  // Reddata smsc environemnt
  'sms.reddata.com.bd': 'reddata',

  // Ranksitt sms environment
  'bsms.ranksitt.net': 'ranksitt',

  // Fahim route app environment
  'bulksmsbd.org': 'fahimit',

  // Voice dev environment
  'voicev1.iatlbd.com': 'voice',
}

const getConfig = (): EnvironmentConfiguration => {
  const hostname = window.location.hostname
  const environemnt = HOSTNAME_TO_ENVIRONMENT[hostname]

  if (!environemnt) {
    console.warn(`[Config] Unknown hostname: ${hostname}, using default config`)
    return ENVIRONMENT_CONFIG['default']
  }

  return ENVIRONMENT_CONFIG[environemnt]
}

const config = getConfig()

export const app_id = config.appId
export const BASE_URL = config.baseUrl
